import styled from "styled-components";
import colorSet from "@/src/styles/color";
import typo from "@/src/styles/typography";

export const AlertBasicContainer = styled.div`
  width: 305px;
  min-height: 158px;
  background: ${colorSet.white};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const AlertTitle = styled.div`
  color: ${colorSet.gray2};
  ${typo.h4};
`;

export const AlertDescription = styled.div`
  color: ${colorSet.gray5};
  ${typo.b8m};
  margin-top: 4px;
`;

export const ButtonArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 265px;
  height: 40px;
  margin: 0 auto;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 40px;
  border-radius: 8px;
  border: none;
  background: ${colorSet.white};
  color: ${colorSet.gray2};
  ${typo.btn3m};
  box-shadow: 0px 0px 0px 0.5px rgba(160, 164, 171, 0.2), 0px 1px 2px rgba(5, 29, 57, 0.1);
  cursor: pointer;
`;

export const OkButton = styled.button`
  flex: 1;
  height: 40px;
  border-radius: 8px;
  border: none;
  background: ${colorSet.indigo};
  color: ${colorSet.white};
  ${typo.btn3m};
  box-shadow: 0px 0px 0px 0.5px rgba(160, 164, 171, 0.2), 0px 1px 2px rgba(5, 29, 57, 0.1);
  cursor: pointer;
`;

export const AlertBasicModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.2);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
`; 